/**
 * Hydrate product-card deferred slides (data-deferred-src / data-deferred-srcset).
 * @param {HTMLElement} root .js-productItem or [data-component="productMedia"]
 * @param {{ full?: boolean }} options full: all slides; otherwise slide data-index="1" only
 */
export default function hydrateProductCardDeferredMedia(root, { full = false } = {}) {
  const hydrateImage = (img) => {
    if (!img || img.dataset.hydrated === 'true') return;

    const { deferredSrc, deferredSrcset } = img.dataset;
    if (!deferredSrc && !deferredSrcset) return;

    if (deferredSrcset) img.srcset = deferredSrcset;
    if (deferredSrc) img.src = deferredSrc;
    img.dataset.hydrated = 'true';

    if (img.complete) {
      img.classList.remove('opacity-0');
    } else {
      img.onload = () => img.classList.remove('opacity-0');
    }
  };

  const hydrateVideo = (video) => {
    if (!video || video.dataset.hydrated === 'true') return;
    if (!video.dataset.src) return;

    video.muted = true;
    video.defaultMuted = true;
    video.src = video.dataset.src;
    video.load();
    video.dataset.hydrated = 'true';
  };

  const slideSelector = full ? '.swiper-slide' : '.swiper-slide[data-index="1"]';

  root.querySelectorAll(slideSelector).forEach((slide) => {
    slide.querySelectorAll('.js-deferredImage').forEach(hydrateImage);
    slide.querySelectorAll('.js-deferredVideo').forEach(hydrateVideo);
  });
}
